import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {QbTransactionDto} from "../model/QbTransactionDto";
import {DebounceFactory} from "../modules/DebounceModule";
import {QbTxnType} from "../model/QbTxnType";
import {StateService} from "@uirouter/angularjs";

class QbTransactionHistoryController implements IComponentController {
    private customerGuid: string;
    private disposeBag = new DisposeBag();
    private transactions: QbTransactionDto[];
    private years: number[];
    private filterYear: number;

    constructor(private $dataHub: DataHubService, private $scope, private $debounce: DebounceFactory,
                private $state: StateService) {
        $dataHub.onConnected(this.reloadDebounce, this.disposeBag);
        $dataHub.bindAllQbTransaction(() => this.transactions, this.disposeBag);
        $dataHub.onQbTransactionUpdated(_ => this.updateYears(), this.disposeBag);
    }

    reload = () => {
        if (!this.customerGuid) return;
        this.$dataHub.qbTransactionSubscribeAndQuery(this.customerGuid)
            .then(ret => {
                this.transactions = ret;
                this.updateYears();
            })
            .catch(this.$dataHub.defaultErrorHandler);
    };

    reloadDebounce = this.$debounce(this.reload, 1000, false);

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reloadDebounce();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }


    updateYears() {
        let years = this.transactions.map(t => t.txnDate.getFullYear());
        let set = new Set(years);
        years = [...set];
        years.sort((a, b) => b - a);
        this.years = years;
    }

    filterFunc = (txn: QbTransactionDto) => {
        if (!this.filterYear) return true;
        if (txn.txnDate.getFullYear() == this.filterYear) return true;
        return false;
    }
}

export default angular.module('component.qbTransactionHistory', [])
    .component('qbTransactionHistory', {
        template: require('./QbTransactionHistory.html'),
        controller: QbTransactionHistoryController,
        bindings: {
            customerGuid: '<',
        }
    }).name;
